import * as React from 'react';
import { RetsinfoChange, RetsinfoReasonForChange, RetsinfoRecordFlagValue } from '../../../../../amorg-common';
import { Button } from '../../../../../designSystem/button/Button';
import { InfoChip } from '../../../../../designSystem/Chip';
import { colors } from '../../../../../designSystem/colors/color';
import { Flex, FlexItem } from '../../../../../designSystem/compositeComponents/FlexHelpers';
import { Link } from '../../../../../designSystem/Link';
import { H4 } from '../../../../../designSystem/typography/Heading';
import { ListRow } from '../../../../../designSystem/compositeComponents/ListRow';

type RetsInfoDocumentPanelProps = {
    change: RetsinfoChange;
    changeIndex: number;
    onClickRefetch: () => void;
    onClickSetFlag: (flagValue: RetsinfoRecordFlagValue) => void;
};
export function RetsInfoDocumentPanel ({ change, changeIndex, onClickRefetch, onClickSetFlag }: RetsInfoDocumentPanelProps): JSX.Element
{
    function reasonText (reason: RetsinfoReasonForChange)
    {
        if (reason === 'Unknown')
            return 'Ukendt';
        if (reason === 'DocumentMetadataChanged')
            return 'Metadata ændret';
        if (reason === 'DocumentContentChanged')
            return 'Indhold ændret';
        if (reason === 'DocumentMetadataChangedAndDocumentContentChanged')
            return 'Metadata og indhold ændret';
        if (reason === 'NewDocument')
            return 'Nyt dokument';
        if (reason === 'RemovedDocument')
            return 'Dokument fjernet';
        return 'Ukendt årsag';
    }

    function stripColor(change: RetsinfoChange)
    {
        if(change.documentData.status === 'error')
        {
            return colors.icon.error;
        }
        if(change.documentData.status === 'not fetched')
        {
            return colors.icon.warning;
        }
        if(change.documentData.status === 'fetched' && change.flag === 'hide')
        {
            return colors.icon.passive;
        }
        return colors.text.active;
    }   

    const htmlLink = change.changeData.href.replace('xml', 'html');

    const importantChangeTypes: RetsinfoReasonForChange[] = [
        'Unknown',
        'DocumentContentChanged',
        'DocumentMetadataChangedAndDocumentContentChanged',
        'NewDocument',
        'RemovedDocument'
    ];

    return (
        <ListRow styleVariant='outlined'
            stripColor={stripColor(change)}
            content={
                <Flex flexDirection='column'>

                    {change.documentData.status === 'error' &&
                        <Flex flexDirection='column' gap={8}>
                            <H4 style={{ color: colors.icon.error }}>{`#${changeIndex + 1}`} Fejl ved hentning af dokument</H4>
                            <Link href={htmlLink} target='_blank'>
                                {htmlLink}
                            </Link>
                            <Flex gap={8} alignItems='center'>
                                <FlexItem flexGrow='1'>
                                    <small>{change.documentData.message}</small>
                                </FlexItem>

                                <Button variant='outlined' icon='interface_actions_download' toolTipText='Genindlæs dokument' onClick={() => onClickRefetch()} />
                            </Flex>
                        </Flex>}

                    {change.documentData.status === 'not fetched' &&
                        <Flex flexDirection='column' gap={8}>
                            <H4>{`#${changeIndex + 1}`} Dokument ikke hentet</H4>
                            <Link href={htmlLink} target='_blank'>
                                {htmlLink}
                            </Link>

                            <Flex>
                                <FlexItem flexGrow='1'>
                                    <Flex flexDirection='column' gap={8}>
                                        <Flex gap={8} alignItems='center'>
                                            <InfoChip variant="outlined">{change.changeData.documentType.shortName}</InfoChip>
                                            <InfoChip variant={importantChangeTypes.includes(change.changeData.reasonForChange) ? 'filled' : 'outlined'}>
                                                {reasonText(change.changeData.reasonForChange)}
                                            </InfoChip>
                                        </Flex>
                                    </Flex>
                                </FlexItem>

                                <Flex gap={8} alignItems='center'>
                                    {change.flag === 'hide' &&
                                        <Button variant='outlined' text='vis' onClick={() => onClickSetFlag('none')} />}
                                    {change.flag === 'none' &&
                                        <Button variant='destructive' text='skjul' onClick={() => onClickSetFlag('hide')} />}
                                    <Button variant='outlined' icon='interface_actions_download' toolTipText='Indlæs dokument' onClick={() => onClickRefetch()} />
                                </Flex>
                            </Flex>
                        </Flex>}

                    {change.documentData.status === 'fetched' &&
                        <Flex flexDirection='column' gap={8}>
                            <Flex justifyContent='space-between' alignItems='center'>
                                <H4>{`#${changeIndex + 1}`} {change.documentData.data.documentTitle}</H4>
                                <small>#{change.changeData.documentId}</small>
                            </Flex>

                            <Flex gap={8} justifyContent='space-between' alignItems='center'>
                                <Link href={htmlLink} target='_blank'>
                                    {htmlLink}
                                </Link>

                                <div>
                                    {change.flag === 'hide' &&
                                        <Button variant='outlined' size='32px' text='vis' onClick={() => onClickSetFlag('none')} />}
                                    {change.flag === 'none' &&
                                        <Button variant='destructive' size='32px' text='skjul' onClick={() => onClickSetFlag('hide')} />}
                                </div>
                            </Flex>

                            <Flex gap={8} alignItems='center'>
                                <InfoChip variant="outlined">{change.documentData.data.ministry}</InfoChip>
                                <InfoChip variant="outlined">{change.changeData.documentType.shortName}</InfoChip>
                                <InfoChip variant={importantChangeTypes.includes(change.changeData.reasonForChange) ? 'filled' : 'outlined'}>

                                    {reasonText(change.changeData.reasonForChange)}

                                </InfoChip>
                            </Flex>

                        </Flex>
                    }
                </Flex>
            }
        />
    );
}